import { Link } from "react-router-dom";
import { contactInfo } from "@/mocks/site/content";

export default function SiteFooter() {
  return (
    <footer className="bg-[#1A1410] text-cream-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12">
          {/* Brand block */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-brand-500 text-white">
                <i className="ri-truck-fill text-xl"></i>
              </div>
              <div className="leading-tight">
                <div className="font-display text-xl font-bold text-white">Haulmark</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-cream-100/60">Movers</div>
              </div>
            </div>
            <p className="text-sm text-cream-100/70 leading-relaxed max-w-sm mb-5">
              Family-owned, fully insured, flat-rate moving company. Treating your stuff like it's ours since 2007.
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-facebook-fill", href: "#" },
                { icon: "ri-twitter-x-line", href: "#" },
                { icon: "ri-youtube-line", href: "#" },
                { icon: "ri-tiktok-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-white/5 hover:bg-brand-500 text-cream-100 hover:text-white transition-colors cursor-pointer"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-cream-100/50 font-semibold mb-4">
              Company
            </div>
            <ul className="space-y-2.5 text-sm text-cream-100/80">
              <li><Link to="/" className="hover:text-brand-300 cursor-pointer">Home</Link></li>
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Services</Link></li>
              <li><Link to="/site/about" className="hover:text-brand-300 cursor-pointer">About Us</Link></li>
              <li><Link to="/site/contact" className="hover:text-brand-300 cursor-pointer">Contact</Link></li>
              <li><a href="#" className="hover:text-brand-300 cursor-pointer">Careers</a></li>
              <li><a href="#" className="hover:text-brand-300 cursor-pointer">Press</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-cream-100/50 font-semibold mb-4">
              Services
            </div>
            <ul className="space-y-2.5 text-sm text-cream-100/80">
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Residential</Link></li>
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Office & Commercial</Link></li>
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Long Distance</Link></li>
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Packing & Unpacking</Link></li>
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Storage</Link></li>
              <li><Link to="/site/services" className="hover:text-brand-300 cursor-pointer">Specialty Items</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-cream-100/50 font-semibold mb-4">
              Get in touch
            </div>
            <ul className="space-y-3 text-sm text-cream-100/80">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-brand-300">
                  <i className="ri-phone-line"></i>
                </span>
                <a href={`tel:${contactInfo.phoneSales.replace(/[^\d]/g, "")}`} className="hover:text-brand-300 cursor-pointer">
                  {contactInfo.phoneSales}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-brand-300">
                  <i className="ri-mail-line"></i>
                </span>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-brand-300 cursor-pointer break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-brand-300">
                  <i className="ri-map-pin-line"></i>
                </span>
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust strip */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] uppercase tracking-[0.16em] text-cream-100/40 font-semibold">
            <span>USDOT #2841930</span>
            <span className="w-1 h-1 rounded-full bg-cream-100/30"></span>
            <span>MC-984210</span>
            <span className="w-1 h-1 rounded-full bg-cream-100/30"></span>
            <span>Licensed · Bonded · Insured</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-cream-100/60">
            <a href="#" className="hover:text-brand-300 cursor-pointer">Privacy</a>
            <a href="#" className="hover:text-brand-300 cursor-pointer">Terms</a>
            <a href="#" className="hover:text-brand-300 cursor-pointer">Sitemap</a>
            <span>© 2026 Haulmark Movers · All rights reserved</span>
          </div>
        </div>
      </div>
    </footer>
  );
}